<template>
  <div class="start">
    <h1>Über mich</h1>
    <p>Ich bin Maike, Mama von zwei kleinen Sonnenscheinen, Ärztin und zertifizierte <strong>BFB bindungsorientierte Familienbegleiterin®</strong>. Mit Einfühlungsvermögen und einem offenen Ohr begleite ich dich auf deinem individuellen Weg - auf wissenschaftlich fundierter Basis!</p>
    <p>Leider musste ich - gerade beim ersten Kind - die Erfahrung machen, dass zum Thema Kindererziehung jeder seinen Senf dazugeben möchte. Sei es der Opa, die Schwiegermutter oder die Nachbarin des Onkels des Dackels deiner Cousine.</p>
    <blockquote>
      <p>„Leg das Kind doch mal ab, sonst verwöhnst du es!“</p>
      <p>„Stillst du SCHON WIEDER?“</p>
      <p>„Schläft es denn immer noch nicht durch? Das ist doch nicht normal!“</p>
      <p>„Ihr müsst es auch mal schreien lassen, dann lernt es alleine einzuschlafen.“</p>
    </blockquote>
    <p>Solche Aussagen bekam ich gefühlt täglich zu hören. Das hat mich damals sehr verunsichert, denn schließlich hat man als frischgebackene Mama eh schon ständig das Gefühl, alles falsch zu machen. Also habe ich angefangen, mich zu informieren, und dabei festgestellt, wie viele Mythen und Fehlinformationen in der Familie, in Krabbelgruppen und gerade im Internet kursieren.</p>
    <p>Deshalb ist es mir ein Herzensanliegen, (werdenden) Eltern auf Augenhöhe zu begegnen und sie zu bestärken, Vertrauen in sich selbst zu finden. Und manchmal auch einfach nur zu sagen: <i>„Du machst das richtig gut!“</i></p>
    <p>Ob Fragen zum Stillen, Schlafen oder zur Beikost –  ihr müsst da nicht alleine durch! Ich bin da, um zuzuhören und Impulse mitzugeben, die sich auch realistisch in euren Familienalltag integrieren lassen. Deshalb gibt es bei mir keine starren Pläne, sondern verschiedene Lösungsansätze, die wir individuell an eure Situation anpassen. Denn jede Familie hat andere Bedürfnisse. Am Ende könnt ihr so informierte Entscheidungen treffen, die sich für euch richtig anfühlen – <strong>ohne Druck, sondern mit Verständnis, Verbundenheit und Vertrauen!</strong></p>
    <p>Ich freue mich darauf, euch und eure Familie kennenzulernen und ein Stück eures Weges begleiten zu dürfen!</p>
  </div>
</template>

<script>
export default {
  name: 'Start'
}
</script>

<style scoped>
.start {
}
blockquote p {
  font-style: italic;
  margin: 0.3125rem 0; /* 5px */ /* Reduziert den Abstand zwischen den Zitaten */
}
</style>